import {
    DeleteForever,
    Email,
    NotificationsActive,
    Settings,
    Visibility,
} from "@mui/icons-material";
import {
    Box,
    Button,
    Divider,
    FormControlLabel,
    Switch,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { useState } from "react";
import { Loading } from "../../../components";
import { handleLogout } from "../../../services";
import { useToastStore } from "../../../stores";
import { colorSubText } from "../../../theme";
import { SubmitButton } from "../../company/components/ButtonComponent";
import { AtualizarNotificacaoLojistaDTO } from "../dto/ShopkeeperDTO";
import { apagarContaLojista, atualizarNotificacaoLojista } from "../repository/ShopkeeperRepository";

export function ConfiguracoesTab() {
  const theme = useTheme();
  const { setToast } = useToastStore();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isLoading, setIsLoading] = useState(false);
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [pushNotifications, setPushNotifications] = useState(true);
  const [showPrices, setShowPrices] = useState(true);



const handleUpdateNotifications = async () => { 
    try {
        setIsLoading(true);
        const payload: AtualizarNotificacaoLojistaDTO = { 
            receber_email: emailNotifications,
            receber_push: pushNotifications,
        };
        const result = await atualizarNotificacaoLojista(payload);
        if(!result?.success) {
            setToast({variant:"error", message: result.message});
        return;
        }
        setToast({variant:"success", message: result.message});
    } catch (error) {
        setToast({variant:"error", message: "Erro. Contate o administrador."});
    } finally {
        setIsLoading(false);
    }
}


const handleDeleteAccount = async () => {
    try {
        setIsLoading(true);
        const result = await apagarContaLojista();
        if(!result?.success) {
            setToast({variant:"error", message: result.message});
            return;
        }
        setToast({variant:"success", message: result.message});
        await handleLogout();
    } catch (error) {
        setToast({variant:"error", message: "Erro. Contate o administrador."});
    } finally {
        setIsLoading(false);
    }
}

  if (isLoading) return <Loading fullScreen={true} />;

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      {/* Header */}
      <Box>
        <Typography fontSize="1.75rem" fontWeight={700} mb={1}>
          Configurações
        </Typography>
        <Typography fontSize="1rem" fontWeight={400} color={colorSubText}>
          Gerencie suas preferências e configurações da conta.
        </Typography>
      </Box>

      {/* Notificações Section */}
      <Box
        sx={{
          bgcolor: "background.paper",
          borderRadius: 3,
          p: isMobile ? 2.5 : 4,
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Box display="flex" alignItems="center" gap={1.5} mb={2}>
          <Settings sx={{ color: "primary.main", fontSize: 24 }} />
          <Typography fontSize="1.25rem" fontWeight={700}>
            Notificações
          </Typography>
        </Box>
        <Typography fontSize="0.875rem" color={colorSubText} mb={3}>
          Escolha como você deseja receber atualizações e notificações.
        </Typography>

        <Divider sx={{ mb: 3 }} />

        <Box display="flex" flexDirection="column" gap={2}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            p={2}
            sx={{
              bgcolor: "#f8fafc",
              borderRadius: 2,
              transition: "all 0.2s",
              "&:hover": {
                bgcolor: "#f1f5f9",
              },
            }}
          >
            <Box display="flex" alignItems="center" gap={2}>
              <Email sx={{ color: "#64748b", fontSize: 22 }} />
              <Box>
                <Typography fontSize="0.95rem" fontWeight={600}>
                  Notificações por Email
                </Typography>
                <Typography fontSize="0.8rem" color={colorSubText}>
                  Receba atualizações sobre suas compras e ofertas
                </Typography>
              </Box>
            </Box>
            <FormControlLabel
              control={
                <Switch
                  checked={emailNotifications}
                  onChange={(e) => setEmailNotifications(e.target.checked)}
                  color="primary"
                />
              }
              label=""
            />
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            p={2}
            sx={{
              bgcolor: "#f8fafc",
              borderRadius: 2,
              transition: "all 0.2s",
              "&:hover": {
                bgcolor: "#f1f5f9",
              },
            }}
          >
            <Box display="flex" alignItems="center" gap={2}>
              <NotificationsActive sx={{ color: "#64748b", fontSize: 22 }} />
              <Box>
                <Typography fontSize="0.95rem" fontWeight={600}>
                  Notificações Push
                </Typography>
                <Typography fontSize="0.8rem" color={colorSubText}>
                  Receba alertas no navegador em tempo real
                </Typography>
              </Box>
            </Box>
            <FormControlLabel
              control={
                <Switch
                  checked={pushNotifications}
                  onChange={(e) => setPushNotifications(e.target.checked)}
                  color="primary"
                />
              }
              label=""
            />
          </Box>
        </Box>

        <Box mt={3}>
          <SubmitButton
            title="Salvar Preferências"
            onClick={() => {
              setIsLoading(true);
              setTimeout( async() => {
               await  handleUpdateNotifications();
              },);
            }}
          />
        </Box>
      </Box>

      {/* Preferências de Exibição */}
      <Box
        sx={{
          bgcolor: "background.paper",
          borderRadius: 3,
          p: isMobile ? 2.5 : 4,
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Box display="flex" alignItems="center" gap={1.5} mb={2}>
          <Visibility sx={{ color: "primary.main", fontSize: 24 }} />
          <Typography fontSize="1.25rem" fontWeight={700}>
            Preferências de Exibição
          </Typography>
        </Box>
        <Typography fontSize="0.875rem" color={colorSubText} mb={3}>
          Personalize como as informações são exibidas.
        </Typography>

        <Divider sx={{ mb: 3 }} />

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          p={2}
          sx={{
            bgcolor: "#f8fafc",
            borderRadius: 2,
            transition: "all 0.2s",
            "&:hover": {
              bgcolor: "#f1f5f9",
            },
          }}
        >
          <Box>
            <Typography fontSize="0.95rem" fontWeight={600}>
              Mostrar Preços Detalhados
            </Typography>
            <Typography fontSize="0.8rem" color={colorSubText}>
              Exibir valores completos dos veículos
            </Typography>
          </Box>
          <FormControlLabel
            control={
              <Switch
                checked={showPrices}
                onChange={(e) => setShowPrices(e.target.checked)}
                color="primary"
              />
            }
            label=""
          />
        </Box>
      </Box>

      {/* Zona de Perigo */}
      <Box
        sx={{
          bgcolor: "background.paper",
          borderRadius: 3,
          p: isMobile ? 2.5 : 4,
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          border: "2px solid #fee2e2",
        }}
      >
        <Box display="flex" alignItems="center" gap={1.5} mb={2}>
          <DeleteForever sx={{ color: "#dc2626", fontSize: 24 }} />
          <Typography fontSize="1.25rem" fontWeight={700} color="#dc2626">
            Zona de Perigo
          </Typography>
        </Box>
        <Typography fontSize="0.875rem" color={colorSubText} mb={3}>
          Ações irreversíveis relacionadas à sua conta.
        </Typography>

        <Divider sx={{ mb: 3 }} />

        <Box
          p={3}
          sx={{
            bgcolor: "#fef2f2",
            borderRadius: 2,
            border: "1px solid #fecaca",
          }}
        >
          <Typography fontSize="0.9rem" fontWeight={600} color="#991b1b" mb={1}>
            Excluir Conta Permanentemente
          </Typography>
          <Typography fontSize="0.8rem" color="#7f1d1d" mb={2}>
            Uma vez excluída, sua conta não poderá ser recuperada. Todos os
            seus dados, compras e histórico serão permanentemente removidos.
          </Typography>
          <Button
            variant="outlined"
            color="error"
            startIcon={<DeleteForever />}
            onClick={async () => {
              if (
                window.confirm(
                  "Tem certeza que deseja excluir sua conta? Esta ação é irreversível!"
                )
              ) {
                await handleDeleteAccount();
              }
            }}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderWidth: 2,
              "&:hover": {
                borderWidth: 2,
                bgcolor: "#fee2e2",
              },
            }}
          >
            Excluir Minha Conta
          </Button>
        </Box>
      </Box>
    </Box>
  );
}